import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-register",
  "use": "icon-register-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-register\"><defs><style type=\"text/css\"></style></defs><path d=\"M895.888014 0.127984H127.984002a128.303962 128.303962 0 0 0-127.984002 127.984002v575.928009a127.984002 127.984002 0 0 0 127.984002 127.984002h319.960005v63.992001H255.968004a63.992001 63.992001 0 1 0 0 127.984002h511.936008a63.992001 63.992001 0 0 0 0-127.984002H575.928009v-63.992001h319.960005a128.303962 128.303962 0 0 0 127.984002-127.984002v-575.928009a128.303962 128.303962 0 0 0-127.984002-127.984002z m0 703.912011H127.984002v-575.928009h767.904012z\" p-id=\"8275\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/register.svg
// module id = tk39
// module chunks = 7